/**
 * @module components/common/Truncate
 */


import React from 'react'

// TODO: implement actual truncation


export default ({ children }) => <React.Fragment>{children}</React.Fragment>
